import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class LibrosService {
  
  constructor(private http: HttpClient) {}

  getLibros() {
    return this.http.get("assets/data/libros.json");
  }
}
